import { cn, FormatUtils, PaletteUtils, RoutePaths } from '@shared/utils';
import type { RecipientResponse } from '@shared/api';
import { Button, Text } from '@shared/widgets';
import { Constants } from '@shared/constants';

interface RecipientInfoProps {
  className?: string;
  recipient: RecipientResponse;
}

export const RecipientInfo = (props: RecipientInfoProps) => {
  return (
    <section
      className={cn(
        'flex items-center justify-between bg-white p-4 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <div className='flex gap-2'>
        <div className='flex h-12 w-12 items-center justify-center bg-black'>
          <Text className='' weight='semibold' size='xl' color='white'>
            {FormatUtils.getRecipientInitials(props.recipient)}
          </Text>
        </div>
        <div>
          <Text weight='semibold' size='xl'>
            {FormatUtils.getRecipientName(props.recipient)}
          </Text>
          <Text uppercase weight='semibold' size='xs' color='gray'>
            {props.recipient.iban || props.recipient.accountNumber || '-'}
          </Text>
        </div>
      </div>
      <Button
        color='primary'
        to={
          props.recipient.bic === Constants.VCFC_BIC_SWIFT_CODE
            ? RoutePaths.paymentsInsignia.onNavigate({ recipientId: props.recipient.id, type: props.recipient.type })
            : RoutePaths.paymentsOther.onNavigate({ recipientId: props.recipient.id, type: props.recipient.type })
        }
      >
        + New Payment
      </Button>
    </section>
  );
};
